export const FormRootTestIdFactory = {
    getFormRootBase: () => 'form',
    getFormRootTestId: (testId) => [FormRootTestIdFactory.getFormRootBase(), testId].join('-'),
};
